import { DepotsRecusPage } from './routes/espace-deposant/DepotsRecus.js';
import { PilotagePage, PilotageExpositionPage } from './routes/pilotage/PilotagePage.js';
import { SignaturesPage, SignatureDetailPage } from './routes/signatures/SignaturesPage.js';
// Routage de la régie et gardes de la coquille.
import { CatalogagePage } from './routes/catalogage/CatalogagePage.js';
import { TresoreriePage } from './routes/tresorerie/TresoreriePage.js';
import { LignesPage } from './routes/tresorerie/LignesPage.js';
import { EcartsPage } from './routes/tresorerie/EcartsPage.js';
import { DepensesPage } from './routes/tresorerie/DepensesPage.js';
import { PrevisionPage } from './routes/tresorerie/PrevisionPage.js';
import { ImportPage } from './routes/tresorerie/ImportPage.js';
import { TresorerieReglagesPage } from './routes/reglages/TresorerieReglagesPage.js';
import { PaiementEnLignePage } from './routes/paiement-en-ligne/PaiementEnLignePage.js';
import { EncaissementDetailPage } from './routes/paiement-en-ligne/EncaissementDetailPage.js';
import { ReservationsPage } from './routes/rendez-vous-en-ligne/ReservationsPage.js';
import { RendezVousEnLignePage } from './routes/reglages/RendezVousEnLignePage.js';
import { AssistantPage } from './routes/boite-reception/AssistantPage.js';
import { AssistantReponsePage } from './routes/reglages/AssistantReponsePage.js';
import { BoitePage } from './routes/boite-reception/BoitePage.js';
import { DelaisPage } from './routes/boite-reception/DelaisPage.js';
import { ReglagesBoitePage } from './routes/boite-reception/ReglagesBoitePage.js';
import { EspacesPage } from './routes/espace-collectionneur/EspacesPage.js';
import { ReglagesEspacePage } from './routes/espace-collectionneur/ReglagesEspacePage.js';
import { EvenementsPage } from './routes/evenements/EvenementsPage.js';
import { EvenementDetailPage } from './routes/evenements/EvenementDetailPage.js';
import { AccueilEvenementPage } from './routes/evenements/AccueilEvenementPage.js';
import { PipelinePage } from './routes/pipeline/PipelinePage.js';
import { ReglagesPipelinePage } from './routes/pipeline/ReglagesPipelinePage.js';
import { ProfilsPage } from './routes/reglages/ProfilsPage.js';
import { PresentationPage } from './routes/presentation/PresentationPage.js';
import { PresentationDetailPage } from './routes/presentation/PresentationDetailPage.js';
import { ModePresentation } from './routes/presentation/ModePresentation.js';
import { NegociationPage } from './routes/reglages/NegociationPage.js';
import { AccrochagePage } from './routes/accrochage/AccrochagePage.js';
import { EspaceDetailPage } from './routes/accrochage/EspaceDetailPage.js';
import { PlanEditeurPage } from './routes/accrochage/PlanEditeurPage.js';
import { AssurancePage } from './routes/assurance/AssurancePage.js';
import { AssuranceReglagesPage } from './routes/reglages/AssuranceReglagesPage.js';
import { ComptesArtistesPage } from './routes/comptes-artistes/ComptesArtistesPage.js';
import { ReleveDetailPage } from './routes/comptes-artistes/ReleveDetailPage.js';
import { AvanceDetailPage } from './routes/comptes-artistes/AvanceDetailPage.js';
import { RegistrePolicePage } from './routes/registre-police/RegistrePolicePage.js';
import { PropositionPage } from './routes/registre-police/PropositionPage.js';
import { InscriptionPage } from './routes/registre-police/InscriptionPage.js';
import { ControlePage, controleLoader } from './routes/registre-police/ControlePage.js';
import { ArchiveRegistrePolicePage } from './routes/archive-registre-police/ArchiveRegistrePolicePage.js';
import { LocationsPage } from './routes/locations/LocationsPage.js';
import { NouvelleLocationPage } from './routes/locations/NouvelleLocationPage.js';
import { LocationDetailPage } from './routes/locations/LocationDetailPage.js';
import { EcheancesLocationsPage } from './routes/locations/EcheancesLocationsPage.js';
import { FacturationArtoseraPage } from './routes/reglages/FacturationArtoseraPage.js';
import { ModulesPage } from './routes/reglages/ModulesPage.js';
import { AddonsPage } from './routes/reglages/AddonsPage.js';
import { InventairePage } from './routes/inventaire/InventairePage.js';
import { CampagneInventairePage } from './routes/inventaire/CampagneInventairePage.js';
import { CaisseDetailPage } from './routes/inventaire/CaisseDetailPage.js';
import { EmplacementsPage } from './routes/reglages/EmplacementsPage.js';
import { CommandeDetailPage } from './routes/boutique/CommandeDetailPage.js';
import { BoutiquePage } from './routes/boutique/BoutiquePage.js';
import { HorsLignePage } from './routes/reglages/HorsLignePage.js';
// Studio.
import { StudioPage, NouveauStudioPage } from './routes/studio/StudioPage.js';
import { TexteStudioPage } from './routes/studio/TexteStudioPage.js';
import { IaPage } from './routes/reglages/IaPage.js';
import { AssistantRecherchePage } from './routes/reglages/AssistantRecherchePage.js';
import { DemanderPage } from './routes/assistant-recherche/DemanderPage.js';
import { AssistantMcpPage } from './routes/reglages/AssistantMcpPage.js';
import { AccesApiPage } from './routes/reglages/AccesApiPage.js';
import { CampagnePage } from './routes/newsletter/CampagnePage.js';
import { NewsletterPage } from './routes/newsletter/NewsletterPage.js';
import { DiffusionPage } from './routes/reglages/DiffusionPage.js';
import { EcheancesContratsPage } from './routes/artistes/EcheancesContratsPage.js';
import { ContratsPage } from './routes/contrats/ContratsPage.js';
import { ViewingRoomsPage } from './routes/viewing-rooms/ViewingRoomsPage.js';
import { ViewingRoomDetailPage } from './routes/viewing-rooms/ViewingRoomDetailPage.js';
import { MouvementDetailPage } from './routes/mouvements/MouvementDetailPage.js';
import { MouvementsPage } from './routes/mouvements/MouvementsPage.js';
import { OffreDetailPage } from './routes/offres/OffreDetailPage.js';
import { OffresPage } from './routes/offres/OffresPage.js';
import { PressePage } from './routes/presse/PressePage.js';
import { ArticlePressePage } from './routes/presse/ArticlePressePage.js';
import { AgendaPage } from './routes/agenda/AgendaPage.js';
import { createBrowserRouter, type RouteObject } from 'react-router';
import { ConnexionLayout } from './routes/connexion/ConnexionLayout.js';
import { ConnexionPage } from './routes/connexion/ConnexionPage.js';
import { ConnexionSsoPage } from './routes/connexion/ConnexionSsoPage.js';
import { ConnexionSso2FAPage } from './routes/connexion/ConnexionSso2FAPage.js';
import { Connexion2FAPage } from './routes/connexion/Connexion2FAPage.js';
import { MotDePasseOubliePage } from './routes/connexion/MotDePasseOubliePage.js';
import { MotDePasseReinitialiserPage } from './routes/connexion/MotDePasseReinitialiserPage.js';
import { InvitationPage } from './routes/invitation/InvitationPage.js';
import { DepotPublicPage } from './routes/depot/DepotPublicPage.js';
import { ArchivePage } from './routes/archive/ArchivePage.js';
import { ConditionsPage } from './routes/conditions/ConditionsPage.js';
import { conditionsLoader } from './routes/conditions/conditionsLoader.js';
import { DoubleAuthentificationPage } from './routes/double-authentification/DoubleAuthentificationPage.js';
import { doubleAuthentificationLoader } from './routes/double-authentification/doubleAuthentificationLoader.js';
import { archiveLoader } from './routes/archive/archiveLoader.js';
import { RegieShell, coquilleLoader } from './routes/shell/RegieShell.js';
import { TableauDeBordPage } from './routes/tableau-de-bord/TableauDeBordPage.js';
import { OeuvresPage } from './routes/oeuvres/OeuvresPage.js';
import { OeuvreDetailPage } from './routes/oeuvres/OeuvreDetailPage.js';
import { StandPage } from './routes/stand/StandPage.js';
import { StandOeuvrePage } from './routes/stand/StandOeuvrePage.js';
import { ArtistesPage } from './routes/artistes/ArtistesPage.js';
import { ArtisteDetailPage } from './routes/artistes/ArtisteDetailPage.js';
import { ContactsPage } from './routes/contacts/ContactsPage.js';
import { ContactDetailPage } from './routes/contacts/ContactDetailPage.js';
import { ExpositionsPage } from './routes/expositions/ExpositionsPage.js';
import { ExpositionDetailPage } from './routes/expositions/ExpositionDetailPage.js';
import { VentesPage } from './routes/ventes/VentesPage.js';
import { FactureDetailPage } from './routes/ventes/FactureDetailPage.js';
import { CoffrePage } from './routes/coffre/CoffrePage.js';
import { DocumentDetailPage } from './routes/coffre/DocumentDetailPage.js';
import { DemandeSitePage } from './routes/site/DemandeSitePage.js';
import { EditeurSiteGarde } from './routes/site/EditeurSiteGarde.js';
import { ReglagesPage } from './routes/reglages/ReglagesPage.js';
import { AccesVenioPage } from './routes/reglages/AccesVenioPage.js';
import { ReglagesSecuritePage } from './routes/reglages/ReglagesSecuritePage.js';
import { LieuxPage } from './routes/reglages/LieuxPage.js';
import { TypesContactPage } from './routes/reglages/TypesContactPage.js';
import { EquipePage } from './routes/reglages/EquipePage.js';
import { ConnecteursPage } from './routes/reglages/ConnecteursPage.js';
import { DocumentsPage } from './routes/reglages/DocumentsPage.js';
import { GardeReglagesLectureSeule } from './routes/reglages/lectureSeule.js';
import { ArchiveFacturesPage } from './routes/archive-factures/ArchiveFacturesPage.js';
import { ArchiveFacturePage } from './routes/archive-factures/ArchiveFacturePage.js';
import { GroupePage } from './routes/groupe/GroupePage.js';
import { NotFoundPage } from './routes/introuvable/NotFoundPage.js';
import { ModuleAVenirPage } from './routes/modules/ModuleAVenirPage.js';
import { racineLoader } from './routes/racine/racineLoader.js';
import { OuvrirEtiquettePage } from './routes/etiquettes/OuvrirEtiquettePage.js';
import { ouvrirEtiquetteLoader } from './routes/etiquettes/ouvrirEtiquetteLoader.js';
import { ErreurChargement } from './routes/racine/ErreurChargement.js';
import { coquilleDoitRevalider } from './routes/racine/horsLigne.js';

/**
 * Arbre de routes en mode data (react-router 7, mission S3-i). Les chargeurs
 * de `routes/loaders.ts` exigent la session et gèrent la redirection « avec
 * retour » vers `/connexion` (401, `docs/dev/api.md` § 3).
 *
 * `routes` est exporté séparément de `router` pour que les tests construisent
 * un `createMemoryRouter(routes, …)` sur le même arbre (routage protégé,
 * mission S3-i point 8).
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    loader: racineLoader,
    errorElement: <ErreurChargement />,
  },
  {
    path: 'connexion',
    element: <ConnexionLayout />,
    children: [
      { index: true, element: <ConnexionPage /> },
      { path: '2fa', element: <Connexion2FAPage /> },
      { path: 'sso', element: <ConnexionSsoPage /> },
      { path: 'sso/2fa', element: <ConnexionSso2FAPage /> },
    ],
  },
  {
    path: 'mot-de-passe/oublie',
    element: <MotDePasseOubliePage />,
  },
  {
    path: 'mot-de-passe/reinitialiser/:token',
    element: <MotDePasseReinitialiserPage />,
  },
  {
    path: 'invitation/:token',
    element: <InvitationPage />,
  },
  {
    // Hors coquille : la direction d'une galerie RÉSILIÉE n'a plus de régie,
    // seulement son archive, jusqu'à la purge (ARTO-54).
    path: 'archive',
    element: <ArchivePage />,
    loader: archiveLoader,
  },
  {
    // Hors coquille et sans session : le lien de dépôt public d'une reprise
    // (A5, ARTO-129). Le jeton est l'autorisation ; `depot` est un slug réservé.
    path: 'depot/:jeton',
    element: <DepotPublicPage />,
  },
  {
    // Hors coquille : l'adresse du QR d'une étiquette interne. La connexion
    // ramène ici, puis la fiche s'ouvre dans la galerie qui a émis le jeton.
    // Un slug compte au moins trois caractères : `e` n'en est jamais un.
    path: 'e/:jeton',
    element: <OuvrirEtiquettePage />,
    loader: ouvrirEtiquetteLoader,
    errorElement: <ErreurChargement />,
  },
  {
    // Hors coquille : les conditions générales d'utilisation s'acceptent
    // avant d'entrer dans une galerie, et se consultent ensuite (ARTO-59).
    path: 'app/conditions',
    element: <ConditionsPage />,
    loader: conditionsLoader,
    errorElement: <ErreurChargement />,
  },
  {
    // Hors coquille : une session dont la grâce est échue ne peut plus que
    // s'enrôler à la double authentification, et la coquille appellerait des
    // routes que l'API lui refuse.
    path: 'app/double-authentification',
    element: <DoubleAuthentificationPage />,
    loader: doubleAuthentificationLoader,
    errorElement: <ErreurChargement />,
  },
  {
    path: ':slug/registre-police/controle',
    element: <ControlePage />,
    loader: controleLoader,
    errorElement: <ErreurChargement />,
  },
  {
    path: ':slug',
    id: 'shell',
    element: <RegieShell />,
    loader: coquilleLoader,
    shouldRevalidate: coquilleDoitRevalider,
    errorElement: <ErreurChargement />,
    children: [
      { index: true, element: <TableauDeBordPage /> },
      { path: 'oeuvres', element: <OeuvresPage /> },
      // catalogage
      { path: 'oeuvres/catalogage', element: <CatalogagePage /> },
      { path: 'oeuvres/:id', element: <OeuvreDetailPage /> },
      { path: 'presentation', element: <PresentationPage /> },
      { path: 'presentation/:id', element: <PresentationDetailPage /> },
      { path: 'presentation/:id/plein-ecran', element: <ModePresentation /> },
      { path: 'stand', element: <StandPage /> },
      { path: 'stand/:oeuvreId', element: <StandOeuvrePage /> },
      { path: 'artistes', element: <ArtistesPage /> },
      { path: 'artistes/contrats', element: <EcheancesContratsPage /> },
      { path: 'tresorerie', element: <TresoreriePage /> },
      { path: 'tresorerie/lignes', element: <LignesPage /> },
      { path: 'tresorerie/ecarts', element: <EcartsPage /> },
      { path: 'tresorerie/depenses', element: <DepensesPage /> },
      { path: 'tresorerie/prevision', element: <PrevisionPage /> },
      { path: 'tresorerie/import', element: <ImportPage /> },
      { path: 'paiement-en-ligne', element: <PaiementEnLignePage /> },
      { path: 'paiement-en-ligne/encaissements/:id', element: <EncaissementDetailPage /> },
      { path: 'pilotage', element: <PilotagePage /> },
      { path: 'pilotage/expositions/:id', element: <PilotageExpositionPage /> },
      { path: 'signatures', element: <SignaturesPage /> },
      { path: 'signatures/:id', element: <SignatureDetailPage /> },
      { path: 'comptes-artistes', element: <ComptesArtistesPage /> },
      { path: 'comptes-artistes/releves/:id', element: <ReleveDetailPage /> },
      { path: 'comptes-artistes/avances/:id', element: <AvanceDetailPage /> },
      { path: 'artistes/:id', element: <ArtisteDetailPage /> },
      { path: 'agenda', element: <AgendaPage /> },
      { path: 'rendez-vous-en-ligne', element: <ReservationsPage /> },
      { path: 'evenements', element: <EvenementsPage /> },
      { path: 'evenements/:id', element: <EvenementDetailPage /> },
      { path: 'evenements/:id/accueil', element: <AccueilEvenementPage /> },
      { path: 'presse', element: <PressePage /> },
      { path: 'presse/:id', element: <ArticlePressePage /> },
      // Studio.
      { path: 'studio', element: <StudioPage /> },
      { path: 'studio/nouveau', element: <NouveauStudioPage /> },
      { path: 'studio/:id', element: <TexteStudioPage /> },
      { path: 'expositions', element: <ExpositionsPage /> },
      { path: 'expositions/:id', element: <ExpositionDetailPage /> },
      { path: 'espaces-collectionneurs', element: <EspacesPage /> },
      { path: 'contacts', element: <ContactsPage /> },
      { path: 'contacts/:id', element: <ContactDetailPage /> },
      { path: 'ventes', element: <VentesPage /> },
      { path: 'offres', element: <OffresPage /> },
      { path: 'pipeline', element: <PipelinePage /> },
      { path: 'demander', element: <DemanderPage /> },
      { path: 'boite-reception', element: <BoitePage /> },
      { path: 'boite-reception/assistant', element: <AssistantPage /> },
      { path: 'boite-reception/delais', element: <DelaisPage /> },
      { path: 'boite-reception/:id', element: <BoitePage /> },
      { path: 'offres/:id', element: <OffreDetailPage /> },
      { path: 'ventes/:id', element: <FactureDetailPage /> },
      { path: 'viewing-rooms', element: <ViewingRoomsPage /> },
      { path: 'viewing-rooms/:id', element: <ViewingRoomDetailPage /> },
      // Archive des factures (D21) : lecture seule, quand `ventes` est coupé.
      { path: 'registre-police', element: <RegistrePolicePage /> },
      { path: 'registre-police/propositions/nouvelle', element: <PropositionPage /> },
      { path: 'registre-police/propositions/:id', element: <PropositionPage /> },
      { path: 'registre-police/:numero', element: <InscriptionPage /> },
      { path: 'archive-registre-police', element: <ArchiveRegistrePolicePage /> },
      { path: 'archive-factures', element: <ArchiveFacturesPage /> },
      { path: 'archive-factures/:id', element: <ArchiveFacturePage /> },
      {
        path: 'mouvements',
        element: <MouvementsPage />,
      },
      { path: 'assurance', element: <AssurancePage /> },
      { path: 'mouvements/:id', element: <MouvementDetailPage /> },
      { path: 'inventaire', element: <InventairePage /> },
      { path: 'inventaire/campagnes/:id', element: <CampagneInventairePage /> },
      { path: 'inventaire/caisses/:id', element: <CaisseDetailPage /> },
      { path: 'locations', element: <LocationsPage /> },
      { path: 'locations/nouveau', element: <NouvelleLocationPage /> },
      { path: 'locations/echeances', element: <EcheancesLocationsPage /> },
      { path: 'locations/:id', element: <LocationDetailPage /> },
      { path: 'contrats', element: <ContratsPage /> },
      { path: 'coffre', element: <CoffrePage /> },
      { path: 'coffre/:id', element: <DocumentDetailPage /> },
      { path: 'site', element: <EditeurSiteGarde /> },
      { path: 'demande-site', element: <DemandeSitePage /> },
      { path: 'newsletter', element: <NewsletterPage /> },
      { path: 'newsletter/campagnes/:id', element: <CampagnePage /> },
      { path: 'boutique', element: <BoutiquePage /> },
      { path: 'boutique/commandes/:id', element: <CommandeDetailPage /> },
      {
        path: 'reglages',
        // Consultation hors ligne : les écrans qui écrivent restent fermés.
        element: <GardeReglagesLectureSeule />,
        children: [
          { index: true, element: <ReglagesPage /> },
          { path: 'profils', element: <ProfilsPage /> },
          { path: 'negociation', element: <NegociationPage /> },
          { path: 'rendez-vous-en-ligne', element: <RendezVousEnLignePage /> },
          { path: 'addons', element: <AddonsPage /> },
          { path: 'facturation-artosera', element: <FacturationArtoseraPage /> },
          { path: 'modules', element: <ModulesPage /> },
          { path: 'espace-collectionneur', element: <ReglagesEspacePage /> },
          { path: 'pipeline', element: <ReglagesPipelinePage /> },
          { path: 'boite-reception', element: <ReglagesBoitePage /> },
          { path: 'hors-ligne', element: <HorsLignePage /> },
          { path: 'securite', element: <ReglagesSecuritePage /> },
          { path: 'lieux', element: <LieuxPage /> },
          { path: 'types-contact', element: <TypesContactPage /> },
          { path: 'emplacements', element: <EmplacementsPage /> },
          { path: 'emplacements/:id', element: <EmplacementsPage /> },
          { path: 'equipe', element: <EquipePage /> },
          { path: 'documents', element: <DocumentsPage /> },
          { path: 'connecteurs', element: <ConnecteursPage /> },
          { path: 'acces-api', element: <AccesApiPage /> },
          { path: 'assistant-reponse', element: <AssistantReponsePage /> },
          { path: 'ia', element: <IaPage /> },
          { path: 'assistant-mcp', element: <AssistantMcpPage /> },
          { path: 'assistant-recherche', element: <AssistantRecherchePage /> },
          { path: 'tresorerie', element: <TresorerieReglagesPage /> },
          { path: 'assurance', element: <AssuranceReglagesPage /> },
          { path: 'diffusion', element: <DiffusionPage /> },
          { path: 'acces-venio', element: <AccesVenioPage /> },
        ],
      },
      { path: 'groupe', element: <GroupePage /> },
      // Fiche statique d'un module à venir : aucune route du module n'est appelée.
      { path: 'modules/:id', element: <ModuleAVenirPage /> },
      { path: 'depots-recus', element: <DepotsRecusPage /> },
      { path: 'accrochage', element: <AccrochagePage /> },
      { path: 'accrochage/espaces/:id', element: <EspaceDetailPage /> },
      { path: 'accrochage/plans/:id', element: <PlanEditeurPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
];

/**
 * Fabrique plutôt que constante au niveau module : `createBrowserRouter`
 * déclenche le chargeur de la route initiale dès sa création, avant même le
 * montage de `<RouterProvider>`. `main.tsx` doit donc pouvoir activer le mode
 * démonstration (`activerModeDemonstrationDepuisUrl`) avant d'appeler cette
 * fabrique — un `export const router = …` s'évaluerait à l'import du module,
 * potentiellement avant cette activation.
 */
export function creerRouteur() {
  // The public template preview serves the same real régie beneath a path
  // prefix. React Router applies this basename to every Link and navigate().
  const basename = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';
  return createBrowserRouter(routes, { basename });
}
